<template>
    <div>
        <CommonTitle :title="modelTitle" :showMore="true" @goMore="goSquare" :tag-list="tagList" @changeTag="onChangeTag"/>
         <ul class="excellent-lesson" v-if="realList.length" v-loading="loading">
            <li class="excellent-lesson-item" v-for="item in realList" :key="item.id" @click="toDetail(item.id)">
                <div class="list-item-link" v-link="linkUrl(item.id)">
                    <div class="list-item-img">
                        <LazyImage :src="item.coverUrl" className="img" />
                    </div>
                    <div class="list-item-content">
                        <p class="title">
                            <Ellipsis :rows="2" :content="item.lessonName"/>
                        </p>
                        <p class="semester-stage">
                            学段学科：<span class="black-c"><Ellipsis :content="item.stageSubjectName"/></span>
                        </p>
                        <p class="create-title overflow-ellipsis" :title="`授课老师：${item.lectureTeacherName}`">
                            授课老师：{{item.lectureTeacherName}}
                        </p>
                        <div class="create-time">{{dayjs(item.gmtCreate).format('YYYY.MM.DD')}}</div>
                    </div>
                </div>
            </li>
        </ul>
        <BigNoData v-else class="no-data" url="no-course.png" :info="`暂无${modelTitle || '优秀课例'}`" />
    </div>
</template>
<script setup>
import Ellipsis from '@/components/ellipsis.vue';
import CommonTitle from '@/components/home-common-title/index.vue'
import BigNoData from '@/components/no-data.vue'
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex'
import dayjs from 'dayjs';
import { pageJump } from '@/global/location-transfer'
import { jumpHref } from '@/router/jumpHref.js';
import { handleStageSubject } from '@/lib/tools.js';

const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    },
    tagList: {
        type: Array,
        default: () => {
            return []
        }
    },
    doubleNew: {
        type: Boolean,
        default: false
    }
})


const store = useStore()

const list = ref([]);
const stageSubjectList = ref([])
const loading = ref(false);

const realList = computed(() => {
    let tempList = list.value?.length && list.value.slice(0, 4) || [];
    tempList = tempList.map(item => {
        item.stageSubjectName = handleStageSubject(item.stageSubjectDTOList);
        return item;
    })
    return tempList;
})

const getList = function () {
    loading.value = true;
    G_transmit('lessonSquare', {
        name: 'lessonSquare',
        data: {
            pageSize: 4,
            pageIndex: 1,
            lessonType: 2, // 课程类型 1-听评课 2-案例
            // state: 1, // 启用状态 -1 删除 0：禁用，1：正常
            order: 0,
            bestState: 1, // 是否是优秀案例 0-不是 1-是
            stageSubjectRequestList: stageSubjectList.value // 格式:[{"stageId":1201},{"stageId":1202}]
        }
    }).then(res => {
        list.value = res?.data?.rows || [];
    }).finally(() => {
        loading.value = false;
    });
}

// 跳转广场
function goSquare () {
    pageJump({name: 'videoCaseSquare'});
}

// 跳转案例详情
function toDetail(id) {
    pageJump(jumpHref.videocase.detail(id), true);
}

function linkUrl(id){
    return {
        url: jumpHref.videocase.detail(id),
        className: 'link-item'
    }
}

const onChangeTag = (tag) => {
    let arr = []
    if (tag && tag.length) {
        tag.forEach(el => {
            arr.push({
                stageId: el
            })
        });
    }
    stageSubjectList.value = arr
    getList()
}

onMounted(() => {
    let tag = props.doubleNew ? [1204] : [];
    onChangeTag(tag);
})

</script>

<style lang="scss" scoped>
.excellent-lesson {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    border-radius: 4px;
}

.excellent-lesson-item {
    box-sizing: border-box;
    width: 277px;
    margin-top: 30px;
    margin-right: 30px;
    cursor: pointer;

    &:hover {
         box-shadow: 0px 1px 12px 0px rgba(0,0,0,0.1500);
         .title {
             color: var(--home-main-color) !important;
         }
    }

    &:nth-child(n+4) {
        margin-right: 0;
    }

    .list-item-img {
        width: 100%;
        height: 156px;

        .img {
            width: 100%;
            height: 100%;
            border-radius: 4px 4px 0px 0px;
        }
    }

    .list-item-content {
        box-sizing: border-box;
        position: relative;
        padding: 15px 20px 20px 20px;
        width: 100%;
        border-radius: 0px 0px 4px 4px;
        border: 1px solid #DDDDDD;
        box-sizing: border-box;
        border-top: none;

        .title {
            height: 54px;
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            line-height: 27px;
            word-break: break-all;
        }

        .semester-stage {
            margin-top: 12px;
            color: var(--srt-color-gray);
            display: flex;
            align-items: center;
            .black-c {
                color: var(--srt-main-text-color);
                width: 160px;
            }
        }
        .subject-tag {
            display: inline-block;
            height: 24px;
            max-width: 66px;
            font-size: 14px;
            line-height: 24px;
            border-radius: 12px 12px 12px 0px;
            padding: 0px 12px;
            margin-right: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .yellow-tag {
            color: #B27121;
            background: #FDEFCD;
        }
        .green-tag {
            color: #367258;
            background: #E7F7EC;
        }
        .create-title {
            line-height: 14px;
            margin-top: 10px;
            color: var(--srt-color-gray);
        }
        .create-time {
            line-height: 14px;
            margin-top: 10px;
            color: var(--srt-color-gray);
        }
    }
}

:deep(.link-item){
    width:100%;
}
.no-data {
    margin-top: 50px;
}
</style>